module.exports = __webpack_public_path__ + "img/404.7fce7b3.gif";